import React from 'react'

import Certificates from 'components/pages/certificates'

export const CertificatesPage = () => {
  return <Certificates />
}
